<template>
  <div>
    <vue2-dropzone
      ref="uploader"
      :options="uploadOptions"
      @vdropzone-sending="sending"
      class="px-md-3 p-0"
      :id="'upload-' + task.id"
      @vdropzone-file-added="$emit('added')"
      @vdropzone-complete="$emit('complete')"
      @vdropzone-success="success"
      @vdropzone-error="error"
      @vdropzone-removed-file="$emit('fileRemoved')"
    />
  </div>
</template>
<script>
import Vue2Dropzone from 'vue2-dropzone'
import successSvg from '@/assets/images/common/success-circle.svg'
import errorSvg from '@/assets/images/common/error-circle.svg'

export default {
  props: {
    task: {
      required: true
    },
    uploadDoc: {
      required: true
    }
  },
  mounted() {
    this.addExistingFile()
  },
  computed: {
    uploadOptions() {
      return {
        previewTemplate: `<div class="file-upload-preview">
          <div class="file-upload-progress-container">
            <span class="file-upload-progress" data-dz-uploadprogress></span>
          </div>
          <div class="file-upload-preview">
            <img data-dz-thumbnail />
            <div class="file-upload-text-details">
              <div class="file-upload-doc">${this.uploadDoc.name}</div>
              <div class="dz-filename" data-dz-name></div>
              <span class="dz-remove-link" data-dz-remove>${this.$t(
                'buyers.add.form.removeFile'
              )}</span>
              <div class="dz-error-message"><span data-dz-errormessage></span></div>
            </div>
            <div class="dz-success-mark">
              <img src="${successSvg}" />
            </div>
            <div class="dz-error-mark">
              <img src="${errorSvg}" />
            </div>
          </div>
        </div>`,
        url:
          process.env.VUE_APP_DRIP_API_HOST +
          '/v1/platform/task_flows/' +
          this.task.id,
        paramName: 'task_flow[file]',
        method: 'patch',
        maxFiles: 1,
        thumbnailWidth: 64,
        thumbnailHeight: 64,
        maxFilesize: 50,
        timeout: 120000,
        headers: { Authorization: 'Bearer ' + this.$store.getters.token },
        dictDefaultMessage: `<h3 class="upload-placeholder-title mb-2">
          ${this.placeHolderMessage('title', this.uploadDoc)}
        </h3><p class="text-center mb-4">
          ${this.placeHolderMessage('desc', this.uploadDoc)}
        </p>`
      }
    }
  },
  methods: {
    success(file, response) {
      this.$emit('success', {
        file
      })
      this.$mpTrack('Uploaded File', {
        file: file,
        task: this.task
      })
    },
    error(err) {
      throw new Error(err)
    },
    sending(file, xhr, formData) {
      formData.append('task_flow[tags]', this.uploadDoc.key)
      formData.append('task_flow[file_id]', this.uploadDoc.key)
    },
    stepChange(where) {
      return where === 'back'
        ? this.$emit('prevStep', this.step)
        : this.$emit('nextStep', this.step)
    },
    addExistingFile() {
      this.task.documents
        .filter((doc) => {
          return doc.tags === this.uploadDoc.key
        })
        .forEach((document) => {
          const file = {
            size: document.file_size,
            name: document.file_identifier
          }
          const url = document.file_url
          return this.$refs.uploader.manuallyAddFile(file, url)
        })
    },
    placeHolderMessage(placeholder, doc) {
      return this.$t(
        `buyers.add.form.helpText.uploads.${doc.key}.${placeholder}`
      )
    }
  },
  components: {
    Vue2Dropzone
  }
}
</script>
<style lang="scss" scoped>
.upload-placeholder-title {
  font-weight: 300;
  line-height: 1.6rem;
  font-size: 1.6rem;
  margin-bottom: 0;
}
.doc-upload-container {
  .vue-dropzone {
    background: #fff;
    border: 2px dashed #ccc;
  }
}
</style>
